module.exports = __webpack_public_path__ + "static/img/settings.aea38d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/settings.svg
// module id = mkca
// module chunks = 0